/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Autocomplete, TextField, Typography, Box } from '@mui/material';

const VisualSearch = ({ value, visuals, onChange, error, helperText }) => {
  const selected = visuals.find((v) => v.pageDisplayName === value) || null;
  return (
    <Autocomplete
      options={visuals}
      getOptionLabel={(option) => option.pageDisplayName}
      value={selected}
      onChange={(event, newValue) => {
        onChange(newValue?.pageDisplayName);
      }}
      filterOptions={(options, { inputValue }) => {
        const search = inputValue.trim().toLowerCase();

        if (!search) return options;

        return options.filter((option) => {
          const page = option.pageDisplayName?.toLowerCase() || '';
          const name = option.name?.toLowerCase().trim() || '';
          const desc = option.description?.toLowerCase() || '';

          return page.includes(search) || name.includes(search) || desc.includes(search);
        });
      }}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <Box>
            <Typography>{option?.pageDisplayName}</Typography>
            {option.name && (
              <Typography variant="body2" color="text.secondary">
                {option.name}
              </Typography>
            )}
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField error={error} helperText={helperText} {...params} label="Search Visual" />
      )}
    />
  );
};
export default VisualSearch;
